Vue.component('plans', require('../components/host-subscription/plans.vue').default);
